import { useGetFetch } from '../utils/reactQuery';
import { ApiRoutesEnum } from '../utils/routes';

export const useGetFileStorageFile = (idCandidate?: string, token?: string) => {
  const url = `${ApiRoutesEnum.fileStorage}/${idCandidate}?disposition=attachment&token=${token}`;
  return useGetFetch<Blob>({ url, params: { responseType: 'blob' }, config: { enabled: !!idCandidate && !!token } });
};
